<template>
  <div
    class="vagas-wrapper"
    v-if="vagas.length > 0"
  >
    <div class="vagas-container">
      <Transition
        name="slide-fade"
        mode="out-in"
      >
        <div
          class="vaga-card"
          :key="indice"
        >
          <h3>
            {{ vagaAtual.titulo }}
          </h3>
          <span class="categoria">
            {{ vagaAtual.categoria }}
          </span>

          <p class="descricao">
            {{ vagaAtual.descricao }}
          </p>

          <div class="rodape">
            <span class="data"> Inscrições até {{ vagaAtual.data }} </span>

            <button
              class="detalhes"
              @click="abrirVaga"
            >
              Ver detalhes
            </button>
          </div>
        </div>
      </Transition>
    </div>

    <div class="dots">
      <span
        v-for="(vaga, index) in vagas"
        :key="index"
        class="dot"
        :class="{ active: index === indice }"
        @click="selecionarDot(index)"
      />
    </div>
  </div>
  <div
    class="vagas-wrapper empty-vagas"
    v-else
  >
    <p>Não há vagas disponíveis no momento.</p>
  </div>
</template>

<script>
import vagasService from "@/service/vagasService.js";
import { formatarData, limitarTexto } from "@/utils/FormatarEntradas.js";

export default {
  data() {
    return {
      indice: 0,
      autoPlayTimer: null,
      vagas: [],
    };
  },

  computed: {
    vagaAtual() {
      return this.vagas[this.indice] || {};
    },
  },

  methods: {
    abrirVaga() {
      if (this.vagaAtual && this.vagaAtual.id) {
        this.$router.push({
          name: "VagasView",
          params: { vagaId: this.vagaAtual.id },
        });
      }
    },
    proximo(interacaoUsuario = true) {
      this.indice = (this.indice + 1) % this.vagas.length;

      if (interacaoUsuario) {
        this.reiniciarAutoPlay();
      }
    },

    anterior() {
      this.indice = (this.indice - 1 + this.vagas.length) % this.vagas.length;

      this.reiniciarAutoPlay();
    },

    selecionarDot(index) {
      this.indice = index;
      this.reiniciarAutoPlay();
    },

    iniciarAutoPlay(delay = 5000) {
      clearTimeout(this.autoPlayTimer);

      this.autoPlayTimer = setTimeout(() => {
        this.proximo(false);

        this.iniciarAutoPlay(5000);
      }, delay);
    },

    reiniciarAutoPlay() {
      this.iniciarAutoPlay(20000);
    },
  },

  async mounted() {
    try {
      const response = await vagasService.getVagasFiltradas({
        page: 0,
        size: 5,
        status: "ABERTA",
      });
      const dados = response?.data?.content
        ? response.data
        : response?.content
          ? response
          : response?.data;
      if (dados && dados.content) {
        this.vagas = dados.content.map((v) => ({
          id: v.id,
          titulo: v.titulo,
          categoria: v.acaoTitulo
            ? v.acaoTitulo.replace(/"/g, "")
            : "Vaga de Extensão",
          descricao: limitarTexto(v.textoInformativo, 350),
          data: formatarData(v.dataFimInscricao),
        }));
      }
      if (this.vagas.length > 0) {
        this.iniciarAutoPlay();
      }
    } catch (e) {
      console.error("Erro ao buscar vagas pro carrossel", e);
    }
  },

  beforeUnmount() {
    clearTimeout(this.autoPlayTimer);
  },
};
</script>

<style scoped>
.vagas-wrapper {
  position: relative;
  width: 100%;
  padding: 0;
}

.vagas-container {
  width: 100%;
  height: 450px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-top: none;
  border-radius: 0 0 0.4rem 0.4rem;
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  width: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  height: 36px;
  background: transparent;

  cursor: pointer;
  z-index: 10;
  padding: 0;
  will-change: transform;
  transition: transform 0.2s ease;
}

.arrow img {
  width: 36px;
  height: 36px;
}

.left img {
  transform: rotate(180deg);
}

.left {
  left: 6px;
}

.right {
  right: 6px;
}

.arrow:hover {
  transform: translateY(-50%) scale(1.2);
}
.vaga-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.empty-vagas {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  background-color: #f9f9f9;
  border-radius: 0 0 0.4rem 0.4rem;
  border: 1px dashed #ccc;
  color: #666;
  font-size: 1.1em;
}

.categoria {
  width: fit-content;
  padding: 4px 10px;
  margin-bottom: 1rem;
  border-radius: 30px;
  background: #ece5ff;
  color: #563578;
  font-size: 0.7rem;
  font-weight: 600;
}

h3 {
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 600;
  text-align: center;
}

.descricao {
  line-height: 1.5;
  min-height: calc(1.5em * 8);
  max-height: calc(1.5em * 8);

  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;

  overflow: hidden;
}

.rodape {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  gap: 0.5rem;
}

.data {
  font-size: 0.8rem;
  color: #777;
}

.detalhes {
  background: #3b1f8c;
  color: #fff;
  border: none;
  padding: 0.55rem 0.9rem;
  border-radius: 0.4rem;
  cursor: pointer;
  font-weight: 600;
}

.detalhes:hover {
  background: #2d176d;
}

/* TRANSITION EFFECTS */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(12px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-12px);
}

.dots {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.dot {
  background: #cbd5e1; /* slate-300 */
  border: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  transition: all 0.25s ease;
  outline: none;
}
.dot:hover {
  background: #94a3b8; /* slate-400 */
}
.dot.active {
  background: #3b1f8c; /* Primary color */
  width: 20px;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .descricao {
    min-height: calc(1.5em * 2);
    max-height: calc(1.5em * 2);

    -webkit-line-clamp: 2;
  }
  .vagas-container {
    height: 250px;
    padding: 0.5rem;
  }
  .rodape {
    margin-top: 0rem;
  }
  .dots {
    margin-top: 0.5rem;
  }
  .categoria {
    font-size: 0.5rem;
    margin-bottom: 0.5rem;
  }
}
</style>

.sigla-inline-badge { display: inline-flex; align-items: center;
justify-content: center; padding: 4px 10px; border-radius: 30px; font-size:
0.7rem; font-weight: 600; margin-bottom: 1rem; width: fit-content; }
